import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { WSPlayer } from '../../models/WS-player.model';
import { SpeedPipe } from '../../pipes/speed-pipe';
import { WebSocketService } from '../../services/websocket-service';
import { UnitType } from '../../models/unit.model';
import { DistancePipe } from '../../pipes/distance-pipe';
import { Icon } from '../icon/icon';
import { UISizeType } from '../../models/ui-size.model';
import { CounterEffect } from '../../directives/counter-effect';

@Component({
  selector: 'li[app-player-item]',
  imports: [Icon, CounterEffect],
  templateUrl: './player-item.html',
  styleUrl: './player-item.scss',
  host: {
    '[class.is-client]': 'isClient()',
    '[class]': 'uiSize()',
  },
})
export class PlayerItem {
  private webSocketService: WebSocketService = inject(WebSocketService);
  public uiSize: Signal<UISizeType> = computed(() =>
    this.webSocketService.config()?.rank === 'full' ? 'medium' : 'small',
  );
  player: InputSignal<WSPlayer> = input.required<WSPlayer>();
  index: InputSignal<number> = input.required<number>();
  unit: Signal<UnitType> = computed<UnitType>(() => {
    const unit: string | null = localStorage.getItem('unit');
    if (unit) return unit as UnitType;
    return 'metric';
  });

  private speedPipe: SpeedPipe = new SpeedPipe();
  private distancePipe: DistancePipe = new DistancePipe();

  speedPipeTransform: (value: number) => string = (value: number) =>
    this.speedPipe.transform(
      value,
      this.unit(),
      'both',
    );

  distancePipeTransform: (value: number) => string = (value: number) =>
    this.distancePipe.transform(value, this.unit(), 'both');

  flagUrl: Signal<string | undefined> = computed<string | undefined>(() => {
    const flagCode: string | undefined = this.player().user.countryCode?.split('_')[0];
    return flagCode ? `https://flagcdn.com/${flagCode}.svg` : undefined;
  });

  isClient: Signal<boolean> = computed<boolean>(() => {
    const clientUsername: string | undefined = this.webSocketService.client()?.username;
    const clientAvatarUrl: string | undefined = this.webSocketService.client()?.avatarUrl;
    if (!clientUsername || !clientAvatarUrl) return false;
    return (
      this.player().user.username === clientUsername &&
      this.player().user.avatarUrl === clientAvatarUrl
    );
  });
}
